import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { UserCreatePage } from '@/features/users/pages/UserCreatePage';
import type { UserTypeGroup } from '@/features/users/constants/user.constants';

export const Route = createFileRoute('/_auth/users/create/$category')({
  component: function CreateUserRoute() {
    const { category } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Create User">
        <Suspense fallback={<PageLoader />}>
          <UserCreatePage category={category as UserTypeGroup} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
